export default __webpack_public_path__ + "static/media/90.836e4109.png";